export const tableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  showClomnuBtn: false,
  searchSize: 'mini',
  editBtn: false,
  delBtn: false,
  dialogWidth: '60%',
  column: [{
    label: '标题',
    width: 130,
    prop: 'label',
    rules: [{
      required: true,
      message: '请输入标签名',
      trigger: 'blur'
    }]
  }, {
    label: '类型',
    placeholder: '请输入类型，添加后不可编辑和删除',
    width: 160,
    prop: 'type',
    editDisabled: true,
    rules: [{
      required: true,
      message: '请输入类型',
      trigger: 'blur'
    }]
  }, {
    label: '数据值',
    prop: 'value',
    rules: [{
      required: true,
      message: '请输入数据值',
      trigger: 'blur'
    }]
  }, {
    label: '描述',
    prop: 'description',
    rules: [{
      required: true,
      message: '请输入描述',
      trigger: 'blur'
    }]
  }, {
    label: '排序',
    prop: 'sort',
    type: 'number',
    sortable: true,
    hide: true,
    rules: [{
      required: true,
      message: '请输入排序',
      trigger: 'blur'
    }]
  }]
}
